export const tiles = [
    [0,0,6,6,6,6,6,6,6,6,5,5,6,6,6,6,6,6,6,6],
    [0,0,0,0,6,6,6,6,6,6,6,5,6,6,6,6,6,6,6,6],
    [6,6,0,0,0,6,6,6,6,6,6,5,6,0,0,0,6,6,6,6],
    [6,6,0,6,0,0,6,6,6,5,5,5,6,6,0,0,6,6,6,6],
    [6,6,6,6,0,0,6,6,0,5,5,5,0,0,0,6,6,5,6,6],
    [6,6,6,6,0,0,0,0,0,0,0,0,0,6,5,6,6,6,6,6],
    [6,6,0,0,0,0,0,0,0,6,6,6,0,5,5,6,6,6,6,6],
    [6,6,6,0,0,6,6,6,6,6,6,0,0,5,6,6,6,6,6,6],
    [6,6,6,6,6,6,6,5,5,6,6,0,0,3,3,3,0,0,6,6],
    [6,6,6,5,5,6,6,5,6,6,6,0,0,6,6,6,0,4,6,6],
    [6,6,6,6,6,6,6,5,6,6,6,0,0,6,6,6,0,6,6,6],
    [6,6,6,6,6,6,6,5,6,6,6,0,0,6,6,6,6,6,6,6]

]

